/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DetachAuthClientFromMcpServerRequestBody = {
  /**
   * The auth client id.
   */
  id: string;
  /**
   * The MCP server id.
   */
  mcpServerId: string;
};

/** @internal */
export type DetachAuthClientFromMcpServerRequestBody$Outbound = {
  id: string;
  mcp_server_id: string;
};

/** @internal */
export const DetachAuthClientFromMcpServerRequestBody$outboundSchema:
  z.ZodMiniType<
    DetachAuthClientFromMcpServerRequestBody$Outbound,
    DetachAuthClientFromMcpServerRequestBody
  > = z.pipe(
    z.object({
      id: z.string(),
      mcpServerId: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        mcpServerId: "mcp_server_id",
      });
    }),
  );

export function detachAuthClientFromMcpServerRequestBodyToJSON(
  detachAuthClientFromMcpServerRequestBody:
    DetachAuthClientFromMcpServerRequestBody,
): string {
  return JSON.stringify(
    DetachAuthClientFromMcpServerRequestBody$outboundSchema.parse(
      detachAuthClientFromMcpServerRequestBody,
    ),
  );
}
